import { GridRenderCellParams } from '@mui/x-data-grid';
import { useState } from 'react';
import { PhotoCamera as PhotoCameraIcon } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { CameraConfiguration } from '../../interfaces';
import { CameraConfigurationsDialog } from '../CameraConfigurationsDialog';

const iconStyle = {
    transition: 'all 0.15s ease',
    cursor: 'pointer',
    '&:hover': {
        transform: 'translateY(-3px)',
    },
};

export const CameraConfigurationsCell = (cellValues: GridRenderCellParams) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const configs = cellValues.value as CameraConfiguration[] | undefined | null;

    if (!configs?.length) {
        return null;
    }

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <Tooltip title={`${configs.length} camera configuration${configs.length > 1 ? 's' : ''}`}>
                    <PhotoCameraIcon sx={iconStyle} onClick={() => setIsDialogOpen(true)} />
                </Tooltip>
            </div>

            {isDialogOpen && (
                <CameraConfigurationsDialog
                    cameraConfigurations={configs}
                    open={isDialogOpen}
                    onClose={() => setIsDialogOpen(false)}
                />
            )}
        </>
    );
};
